<template>
  <div class="csat-header">
    <img
      :src="staticImgBaseUrl + '/images/global/clear-icon.svg'"
      @click="handleCrossClick"
    />
    <div>
      <p class="fs-14 fw-800">
        Rate Order <span v-if="orderId">#{{ orderId }}</span>
      </p>
      <span
        class="d-flex fs-11 gap3 color-slaty"
        v-if="
          !overAllRating ||
          (overAllRating && !Object.keys(csatTemplateData).length)
        "
      >
        <span v-if="orderDeliveryType">{{ orderDeliveryType }} </span>
        <span v-if="numberOfItems">
          | {{ numberOfItems }} {{ numberOfItems == 1 ? "item" : "items" }}
        </span>
        <span v-if="price"> | <i class="rs">Rs.</i>{{ price }} </span>
        <span v-if="deliveryTime"> | {{ deliveryTime }}</span>
      </span>
      <span v-else class="fs-11 color-slaty">{{ rateOrderSubtitle }}</span>
    </div>
  </div>
</template>
<script>
import { staticImgBaseUrl } from "../../config/apiEndpoints";
import Utility from "../../helpers/utility";
import LocalStorageFunc from "../../helpers/localStorageFunc";
import PageNames from "../../config/pageNames";
export default {
  name: "CsatHeader",
  data() {
    return {
      staticImgBaseUrl,
      ratingTexts: {
        rate_overall: "Rated Overall",
        completed_food_rating: "Completed Food Rating",
        completed_food_and_delivery_rating:
          "Completed Food and Delivery Rating",
        completed_food_and_service_rating: "Completed Food and Service Rating",
        completed_delivery_rating: "Completed Delivery Rating",
        completed_service_rating: "Completed Service Rating",
      },
    };
  },
  mounted() {},
  methods: {
    handleCrossClick() {
      if (
        LocalStorageFunc.getSessionStorageKey("screenName") ===
        PageNames.ORDERHISTORY_PAGE
      ) {
        Utility.sendToOrderHistory();
      } else {
        Utility.sendToHomepageScreen();
      }
    },
  },
  computed: {
    orderDetails() {
      return this.$store.state.CsatFeedback.orderDetails;
    },
    orderId() {
      return this.orderDetails?.store?.orderId;
    },
    numberOfItems() {
      return this.orderDetails?.numberOfItems;
    },
    orderDeliveryType() {
      const orderDeliveryType = this.orderDetails?.orderDeliveryType;
      return (
        orderDeliveryType?.[0]?.toUpperCase() +
        orderDeliveryType?.slice(1)?.toLowerCase()
      );
    },
    price() {
      return this.orderDetails?.netPrice;
    },
    deliveryTime() {
      return Utility.getDateStringFromTimeStamp(
        this.orderDetails?.deliveryTimeStamp,
      );
    },
    isNewFeedback() {
      return this.$store.state.CsatFeedback.isNewFeedback;
    },
    feedBackData() {
      return this.$store.state.CsatFeedback.feedBackData;
    },
    overAllRating() {
      return this.isNewFeedback ? 0 : this.feedBackData?.overall?.rating;
    },
    csatTemplateData() {
      return this.$store.state.CsatFeedback.csatTemplateData;
    },
    food() {
      return this.$store.state.CsatFeedback.feedBackData?.food;
    },
    delivery() {
      return this.$store.state.CsatFeedback.feedBackData?.delivery;
    },
    orderType() {
      this.feedBackData?.orderType;
    },
    rateOrderSubtitle() {
      if (this.overAllRating && this.food?.length && this.delivery?.length) {
        if (this.orderType == "D") {
          return `${this.ratingTexts.rate_overall} ${this.overAllRating}★️ | ${this.ratingTexts.completed_food_and_delivery_rating}`;
        } else {
          return `${this.ratingTexts.rate_overall} ${this.overAllRating}★️ | ${this.ratingTexts.completed_food_and_service_rating}`;
        }
      } else if (this.overAllRating && this.food?.length) {
        return `${this.ratingTexts.rate_overall} ${this.overAllRating}★️ | ${this.ratingTexts.completed_food_rating}`;
      } else if (this.overAllRating && this.delivery?.length) {
        if (this.orderType == "D") {
          return `${this.ratingTexts.rate_overall} ${this.overAllRating}★️ | ${this.ratingTexts.completed_delivery_rating}`;
        } else {
          return `${this.ratingTexts.rate_overall} ${this.overAllRating}★️ | ${this.ratingTexts.completed_service_rating}`;
        }
      } else {
        return `${this.ratingTexts.rate_overall} ${this.overAllRating}★️`;
      }
    },
  },
};
</script>
